import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { RadioComponent } from '../radio/radio.component';
import { ToggleComponent } from '../toggle/toggle.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { BadgesComponent } from '../badges/badges.component';
import { ActionEvent } from '@services/ui-services/models/action-event';

@Component({
  selector: 'dropdown-single-piece',
  templateUrl: './dropdown-single-piece.component.html',
  styleUrls: ['./dropdown-single-piece.component.scss'],
  imports: [
    CommonModule,
    CeIconComponent,
    RadioComponent,
    ToggleComponent,
    CheckboxComponent,
    BadgesComponent,
    NgOptimizedImage,
  ],
})
export class DropdownSinglePieceComponent {
  @Output() onAction = new EventEmitter<ActionEvent>();
  @Output() onCheckChange = new EventEmitter<any>();
  @Input() id: string = '0';
  @Input() label: string = '';
  @Input() badgeLabel: string = '';
  @Input() color: string = '';
  @Input() type: string = '';
  @Input() state: string = '';
  @Input() image: string = '/assets/avatar.png';
  @Input() showUser: boolean = false;
  @Input() icon: boolean = false;
  @Input() showBadge: boolean = false;
  @Input() badgeType: string = 'tag';
  @Input() iconType: string = '';
  @Input() dragDrop: boolean = false;
  @Input() toggle: boolean = false;
  @Input() more: boolean = false;
  @Input() moreIcon: string = 'chevron_right';
  @Input() moreProps: any = { name: 'chevron_right' };
  @Input() radio: boolean = false;
  @Input() checkbox: boolean = false;
  @Input() value: any = '';
  @Input() checked = false;
  @Input() disabled = false;

  onActionClick($event: MouseEvent) {
    const event = $event as ActionEvent;
    event.key = this.value;
    event.label = this.label;
    this.onAction.emit(event);
  }

  onRadioClick($event: any, value: any) {
    const event = $event as ActionEvent;
    event.key = value || this.value;
    event.label = this.label;
    this.onAction.emit(event);
  }
}
